import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from 'react';
import { useAemConfig } from '@as-react/common-components';
import CustomerApi from '../../../api/customer/CustomerApi';
import { Checkbox, TextAlpha } from '@yonderland/andes-react';
export const NewsletterSubscription = ({ order, newsletter, defaultNewsletterSubscription, }) => {
    const aemConfiguration = useAemConfig();
    const { defaultRequestParams, servicesEndpoint } = aemConfiguration;
    const [subscription, setSubscription] = useState(defaultNewsletterSubscription);
    const [subscriptionUpdated, setSubscriptionUpdated] = useState(false);
    const updateNewsletterSubscription = (subscriptionValue) => {
        const profile_details = {
            email_newsletter: subscriptionValue,
        };
        setSubscriptionUpdated(false);
        try {
            CustomerApi.updatePreferences(servicesEndpoint, defaultRequestParams, profile_details, order.contactPerson);
            setSubscriptionUpdated(true);
        }
        catch (_a) { }
    };
    const toggleNewsletter = (e) => {
        const { checked } = e.target;
        setSubscription(checked);
        updateNewsletterSubscription(checked);
    };
    return (_jsxs(_Fragment, { children: [_jsx(Checkbox, { id: "newsletterSubscription", name: "newsletterSubscription", value: "newsletterSubscription", defaultChecked: defaultNewsletterSubscription, label: newsletter.checkboxText, onChange: toggleNewsletter }), subscription && subscriptionUpdated && _jsx(TextAlpha, { variant: "bodyS", children: newsletter.subscribedMessage }), !subscription && subscriptionUpdated && _jsx(TextAlpha, { variant: "bodyS", children: newsletter.unsubscribedMessage })] }));
};
